// src/router.js
import { createRouter, createWebHistory } from 'vue-router'
import store from './store'
import AssetOverviewPage from './components/AssetOverviewPage.vue'
import InspectionMaintenancePage from './components/InspectionMaintenancePage.vue'
import AssetDataPage from './components/AssetDataPage.vue'

const routes = [
  { path: '/', redirect: '/overview' },
  { path: '/overview', name: 'Overview', component: AssetOverviewPage },
  { path: '/inspection', name: 'Inspection', component: InspectionMaintenancePage },
  { path: '/data', name: 'AssetData', component: AssetDataPage },
  // Legacy paths from the two-tab scaffold.
  { path: '/assets', redirect: '/overview' },
  { path: '/analysis', redirect: '/inspection' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach((to) => {
  store.dispatch('analytics/trackPage', {
    pageUrl: to.fullPath
  })
})

export default router
